module.exports = __webpack_public_path__ + "static/assets/a54e320c72443f66add6887b9c3f8e15.png";